<template>
  <div class="introduce">
    <p align="center">
      <img class="introduce_img" src="../images/6introduce.jpg" />
    </p>
  </div>
</template>

<script>
export default {
  name: "6introduce",
};
</script>

<style scoped lang="scss">
@import "../scss/baseMain";
</style>
